/**
 * 接口说明：
 * 1. 大部分接口是标品和嵌入页共用。
 * 2. 嵌入页路由中带有/embed
 * 3. 嵌入页中使用使用 vod_id 参数，标品使用 record_id 参数。
 * 4. 嵌入页中没有活动信息，所以下载智能解析内容和下载字幕文件使用的video名称，同时视频播放也没有对应的回放文档。
 * 5. 路由 /v3/saas-web-ai/embed/material 在企微中使用。
 */
const apis = {
  // 基础接口
  msgInitConsole: ['/v3/webinars/record/msg-init-console', 'POST'], // 初始化消息
  planFunctionGet: ['/v3/users/permission/get-config-list', 'POST'], // 获取功能配置
  getInfo: ['/v3/users/user/get-info', 'POST'], //获取用户信息（昵称、头像等）场景1：控制台首页 / 场景2：控制台账户信息页

  recordInfo: ['/v3/webinars/record/get-info', 'POST'], // 回放详情(SaaS，使用record_id查询)
  vodInfo: ['/v3/ai/video/paas-vod-info', 'GET'], // 回放详情(PaaS，使用vod_id查询)

  getConfigInfo: ['/v3/ai/video/config-infos', 'GET'], // 嵌入页获取配置信息（嵌入页专用）
  saveConfigInfo: ['/v3/ai/video/config-save', 'POST'], // 嵌入页设置配置信息（嵌入页专用）
  deleteConfigInfo: ['/v3/ai/video/config-delete', 'POST'], // 嵌入页删除配置信息（嵌入页专用）

  playBackPreview: ['/v3/webinars/record/preview', 'POST'],
  playBackInfo: ['/v3/ai/video/paas-access-token', 'GET'],

  getWebinarInfo: ['/v3/webinars/webinar/info', 'POST'], // 查询活动基础信息接口
  getVersionInfo: ['/v3/fin/account/info', 'GET'], //获取用户版本信息

  // 文件上传(图片)
  uploadImage: ['/v3/commons/upload/index', 'POST'], // 文件上传（图片）

  // AI创作通用
  getAiVideoInfo: ['/v3/ai/video/info', 'GET'], //获取ai创作的(结果)信息

  // 智能解析
  getRecordAsr: ['/v3/ai/video/parsing-info', 'GET'], // 查询视频智能解析信息
  createRecordAsr: ['/v3/ai/video/parsing-create', 'POST'], // 智能解析-开始解析
  editRecordAsr: ['/v3/ai/video/parsing-edit', 'POST'], // 智能解析-编辑(批量提交，保存成功即校正完成)
  reviseRecordAsr: ['/v3/ai/video/parsing-revise', 'POST'], // 智能解析-重新校正辑(保存成功点击上一步)

  // 精彩时刻相关接口
  getRecordMonmentConfig: ['/v3/ai/video/moments-config', 'GET'], // 精彩时刻-配置信息查询
  getRecordMonmentInfo: ['/v3/ai/video/moments-info', 'GET'], // 精彩时刻-查询
  createRecordMonment: ['/v3/ai/video/moments-create', 'POST'], // 精彩时刻-开始创作
  updateRecordMonment: ['/v3/ai/video/moments-edit', 'POST'], // 精彩时刻-更新

  // 精彩剪辑
  getRecordClipConfig: ['/v3/ai/video/clip-config', 'GET'], // 精彩剪辑-配置信息查询
  getRecordClipList: ['/v3/ai/video/clip-list', 'GET'], // 精彩剪辑-查询
  createRecordClip: ['/v3/ai/video/clip-create', 'POST'], // 精彩剪辑-开始创作
  addRecordClip: ['/v3/ai/video/clip-add', 'POST'], // 精彩剪辑-精彩片段-新增
  transcodingRecordClip: ['/v3/ai/video/clip-transcoding', 'POST'], // 精彩剪辑-下载到本地
  downloadRecordClip: ['/v3/ai/video/clip-download', 'POST'], // 精彩剪辑-下载到本地查询进度状态
  collectRecordClip: ['/v3/ai/video/clip-collect', 'POST'], // 精彩剪辑-添加至音视频

  // 概要总结
  getSummaryConfig: ['/v3/ai/video/summary-config', 'GET'], // 概要总结-配置信息查询
  getSummaryInfo: ['/v3/ai/video/summary-info', 'GET'], // 概要总结-查询
  createSummary: ['/v3/ai/video/summary-create', 'POST'], // 概要总结 - 创建
  updateSummary: ['/v3/ai/video/summary-edit', 'POST'], // 概要总结 - 更新

  // 智能字幕
  createSubtitles: ['/v3/ai/video/subtitles-create', 'POST'], // 智能字幕-创建
  editSubtitles: ['/v3/ai/video/subtitles-edit', 'POST'], // 智能字幕-编辑
  getSubtitlesInfo: ['/v3/ai/video/subtitles-info', 'GET'], // 智能字幕-信息查询
  getSubtitlesStyleInfo: ['/v3/ai/video/subtitles-style-info', 'GET'], // 智能字幕-样式信息查询
  setSubtitlesStyleInfo: ['/v3/ai/video/subtitles-style-set', 'POST'], // 智能字幕-样式设置
  switchSubtitlesInfo: ['/v3/ai/video/subtitles-switch', 'POST'], // 智能字幕-开关状态切换

  // 登录
  loginInfo: ['/v3/users/user/login', 'POST'], //登录接口  √
  loginOut: ['/v3/users/user/logout', 'POST'], //退出接口  √
  loginCheck: ['/v3/users/user/login-check', 'POST'], //登录账号锁定检测接口
  sendCode: ['/v3/users/code/send', 'POST'], //发送验证码接口
  register: ['/v3/users/user/register', 'POST'], //注册接口
  getLoginKey: ['/v3/users/user/get-key-login', 'POST'], // 获取登录公钥
  refreshToken: ['/v3/users/user/refresh-token', 'post'], // 刷新token

  wxworkAuthorize: ['/v1/ucenter/app/corporation/qw/authorize/web-authorize-url', 'POST'], // 授权，获取企微应用网页授权链接
  checkBindBusiness: ['/v1/ucenter/app/corporation/user/check-bind-business', 'POST'], // 企微用户绑定状态检测
  bindBusinessUid: ['/v1/ucenter/app/corporation/user/bind-business-uid', 'POST'], // 企微用户绑定saas租户ID

  // 音视频资源管理
  dataVideoList: ['/v3/webinars/videos/get-list', 'POST'], //音视频列表 √
  dataVideoupdate: ['/v3/webinars/videos/edit', 'POST'], //音视频编辑 √
  dataVideoDel: ['/v3/webinars/videos/delete', 'POST'], //音视频删除 √
  createVideo: ['/v3/webinars/videos/create', 'POST'], //音视频添加 √
  getAppid: ['/v3/webinars/videos/get-appid', 'POST'], //获取appid接口 √
  getmediaInfo: ['/v3/webinars/record/get-record-info', 'POST'] //获取音视频详情
};

const getApi = api => {
  return apis[api] && apis[api];
};
export default getApi;
